function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M27.832 10.463a25.777 25.777 0 0 1-5.978 5.627l1.448 1.444a.894.894 0 0 1 0 1.221.898.898 0 0 1-1.267.044L5.541 2.335a.893.893 0 0 1 0-1.22.897.897 0 0 1 1.267-.045l1.778 1.772a12.62 12.62 0 0 1 5.837-1.561c7.383 0 13.179 7.794 13.421 8.126a.893.893 0 0 1-.012 1.056zm-10.36 1.262a3.517 3.517 0 0 0 0-3.621 3.533 3.533 0 0 0-4.842-1.213l4.842 4.834zm-3.049-8.653a10.527 10.527 0 0 0-4.502 1.104l1.426 1.423a5.327 5.327 0 0 1 6.163 0 5.305 5.305 0 0 1 1.256 7.406l1.794 1.791a24.173 24.173 0 0 0 5.419-4.861c-1.393-1.692-6.119-6.863-11.556-6.863zM9.096 9.935c0-.495.402-.895.897-.895s.897.4.897.895a3.535 3.535 0 0 0 3.533 3.526.896.896 0 0 1 0 1.79 5.327 5.327 0 0 1-5.327-5.316zM6.638 5.066a.895.895 0 0 1-.115 1.261 25.396 25.396 0 0 0-3.656 3.608c1.393 1.692 6.119 6.862 11.556 6.862a9.54 9.54 0 0 0 2.69-.406.898.898 0 0 1 1.119.599.894.894 0 0 1-.599 1.117 11.329 11.329 0 0 1-3.21.48c-3.082 0-6.388-1.414-9.565-4.09a25.915 25.915 0 0 1-3.859-4.038.891.891 0 0 1 0-1.056 26.101 26.101 0 0 1 4.406-4.476.9.9 0 0 1 1.233.139z"
});

var SvgHide = function SvgHide(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHide, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hide.a4b0d815.svg";
export { ForwardRef as ReactComponent };